export default "__VITE_ASSET__CHxDb8tZ__"